import React, { createContext, useContext, useState, ReactNode } from 'react';

/**
 * 拖拽上下文的类型定义
 */
interface DnDContextType {
  type: string | null;
  setType: (type: string | null) => void;
}

/**
 * 创建拖拽上下文
 */
const DnDContext = createContext<DnDContextType | undefined>(undefined);

/**
 * 拖拽提供者组件的属性
 */
interface DnDProviderProps {
  children: ReactNode;
}

/**
 * 拖拽提供者组件
 * 用于管理拖拽状态，提供拖拽类型的设置和获取功能
 */
export const DnDProvider: React.FC<DnDProviderProps> = ({ children }) => {
  const [type, setType] = useState<string | null>(null);

  return (
    <DnDContext.Provider value={{ type, setType }}>
      {children}
    </DnDContext.Provider>
  );
};

/**
 * 使用拖拽上下文的钩子
 * @returns 返回拖拽类型和设置拖拽类型的函数
 */
export const useDnD = (): [string | null, (type: string | null) => void] => {
  const context = useContext(DnDContext);
  if (context === undefined) {
    throw new Error('useDnD must be used within a DnDProvider');
  }
  return [context.type, context.setType];
}; 